module.exports = __webpack_public_path__ + "img/batman.5f467119.jpeg";